import { action, observable, makeObservable } from 'mobx';
import moment from 'moment';
import { currentTimeZoneStore } from './currentTimeZone';
import { periodFormat } from './periodFormat';

function guessServerTime() {
    return Math.floor(Date.now() / 1000 - currentTimeZoneStore.driftSeconds);
}

export class GuessServerTime {
    @observable
    now: number;

    private readonly interval: number;

    constructor() {
        makeObservable(this);
        this.now = guessServerTime();
        this.interval = window.setInterval(this.updateNow, 500);
    }

    @action
    private updateNow = () => {
        this.now = guessServerTime();
    };

    remainingSeconds(until: number) {
        const result = until - this.now;
        return result >= 0 ? result : 0;
    }

    remainingTimeString(until: number) {
        return periodFormat(this.remainingSeconds(until));
    }

    reached(until: number) {
        return this.remainingSeconds(until) === 0;
    }

    dispose = () => {
        window.clearInterval(this.interval);
    };

    get nowMoment(): moment.Moment {
        return moment(this.now * 1000);
    }
}
